module.exports = __webpack_public_path__ + "img/3dForm4.88c364c4.svg";